import { AxiosRequestConfig } from 'axios';

import { isSessionExpired, refreshSession } from '../auth';

/**
 * Attempt to refresh session if existing token is expired.
 */
async function refreshSessionIfExpired(config: AxiosRequestConfig) {
  if (process.env.NODE_ENV === 'test') {
    return config;
  }

  if (isSessionExpired()) {
    await refreshSession();
  }

  return config;
}

export default refreshSessionIfExpired;
